import React from 'react';

const WidgetContainer = ({ 
  children, 
  className = '',
  delay = 0,
  withSteam = false
}) => {
  return (
    <div 
      className={`glass-card p-6 h-full ${className}`}
      style={{ 
        animationDelay: `${delay}ms`,
        animation: 'fadeIn 0.6s ease-out forwards',
        opacity: 0,
        position: 'relative',
        overflow: 'visible'
      }}
    >
      {children}
    </div>
  );
};

export default WidgetContainer;
